import './Banner.scss';

import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import { useTheme } from '../../hooks/useTheme';
import FINANCE_BANNER_CONTENT from './FinanceBanner.json';

const MobileFinanceBanner = () => {
	const { isDealsPage } = useSelector((state) => state);
	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	const theme = useTheme('financeBanner');

	const { title, repExample, terms } = FINANCE_BANNER_CONTENT;

	return (
		<li
			className={classnames('pt-0', {
				'sm:py-1': isDealsPage,
				'w-full mobile-banner sm:px-1': !CustomCategoriesEnabled,
				' m-2': CustomCategoriesEnabled,
			})}>
			<div
				className={classnames(
					'w-full px-2 py-3 border border-solid border-gray-30',
					theme.background,
					{
						rounded: CustomCategoriesEnabled,
						'mobile-banner-border': !CustomCategoriesEnabled,
					}
				)}>
				<div className="text-center">
					<div className={classnames('text-display-sm px-3', theme.title)}>
						{title}
					</div>
				</div>
				<div className="flex flex-col items-center justify-center mb-2 mt-3 p-1">
					<div className={classnames('text-caption', theme.repExample.title)}>
						{repExample.title}
					</div>

					<div className="flex justify-around w-full">
						{repExample.examples.map((example) => (
							<div className="flex-col text-center px-1" key={example.title}>
								<div
									className={classnames(
										'text-title-sm leading-tight',
										theme.repExample.examples.title
									)}>
									{example.title}
								</div>
								<div
									className={classnames(
										'text-caption leading-tight',
										theme.repExample.examples.description
									)}>
									{example.description}
								</div>
							</div>
						))}
					</div>
				</div>
				<div className={classnames('text-caption text-center', theme.terms)}>
					{terms.regular}
					<span className="font-bold">{terms.bold}</span>
				</div>
			</div>
		</li>
	);
};

export default MobileFinanceBanner;
